export default function getEndTimeCode(timeSeries: AbstractTimeSeries): number
{
    if (!timeSeries.timeCodes.length) {
        throw Error("Time series is empty.");
    }
    return timeSeries.timeCodes[timeSeries.timeCodes.length - 1];
}
